import {
    CHANGE_RECALL_NUMBER,
    CHECK_RECONNECT_SESSION,
    CLEAR_RECALL_SESSION,
    GET_ERROR_USERS_WEB_RTC, GET_MUTE_CONSULTATION_ID,
    GET_MUTE_ID,
    GET_USERS_WEB_RTC,
    RECONNECT_SESSION,
    SET_ACTIVE_SESSION,
    SET_MONITORING_HUB_ERROR,
    SET_RECALL_NUMBER, SET_STATUS_HUB_ERROR, SET_USER_DATA_HUB_ERROR, SET_DIALER_HUB_ERROR, SET_TRANSCRIPTION_HUB_STATUS,
    SUCCESS_SESSION_RECONNECTED,
    CLEAR_ALL_STATES, SET_PICK_UP_NUMBER, PICKUP_CALL_TRIGGER, SET_ERROR_JS_SIP, SET_ERROR_JS_SIP_TAB, SET_SPY_SESSION_ID, SET_SPY_CALL_ANSWERED_TICK, SET_SIP_USER_BUSY
} from "../types/types";
import type {TranscriptionHubStatusPayload} from "../../components/Statistics/ManualEvaluationDialog/manualEvaluationTranscription";
import {CHANGE_INTERNET_STATUS, RECONNECT_TAB, SET_ACTIVE_SESSION_TAB} from "../types/typesWebRTC";

const initialState = {
    searchResults: [],
    error: false,
    muteId: 0,
    muteConsultationId: 0,
    activeSession: true,
    reconnectSession: false,
    successReconnect: false,
    recallNumber: null,
    sessionId: null,
    recallNumberChanged: false,
    internetStatusError: false,
    checkSipConnection: false,
    monitoringHubError: false,
    statusHubError: false,
    userDataHubError: false,
    dialerHubError: false,
    errorJsSip: false,
    errorJsSipTab: false,
    activeTab: true,
    reconnectTab: false,
    pickUpUserName: null,
    pickUpSessionId: null,
    spySessionId: null,
    spyCallAnsweredTick: 0,
    pickupCallTrigger: null,
    sipUserBusy: false,
    transcriptionHubStatus: null as TranscriptionHubStatusPayload | null,
};

export const WebRTCReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_USERS_WEB_RTC:
            return { ...state, searchResults: action.payload };
        case GET_ERROR_USERS_WEB_RTC:
            return { ...state, error: action.payload };
        case GET_MUTE_ID:
            return { ...state, muteId: action.payload };
        case GET_MUTE_CONSULTATION_ID:
            return { ...state, muteConsultationId: action.payload };
        case SET_ACTIVE_SESSION:
            return { ...state, activeSession: action.payload };
        case RECONNECT_SESSION:
            return { ...state, reconnectSession: action.payload };
        case SUCCESS_SESSION_RECONNECTED:
            return { ...state, successReconnect: action.payload };
        case SET_RECALL_NUMBER:
            return { ...state, recallNumber: action.payload.nameTo, sessionId: action.payload.sessionId ?? null };
        case SET_PICK_UP_NUMBER:
            return { ...state, pickUpUserName: action.payload.userName, pickUpSessionId: action.payload.sessionId };
        case SET_SPY_SESSION_ID:
            return { ...state, spySessionId: action.payload };
        case SET_SPY_CALL_ANSWERED_TICK:
            return { ...state, spyCallAnsweredTick: action.payload };
        case SET_SIP_USER_BUSY:
            return { ...state, sipUserBusy: action.payload };
        case PICKUP_CALL_TRIGGER:
            return { ...state, pickupCallTrigger: action.payload };
        case CLEAR_RECALL_SESSION:
            return { ...state, sessionId: null};
        case CHANGE_RECALL_NUMBER:
            return { ...state, recallNumberChanged: action.payload };
        case CHANGE_INTERNET_STATUS:
            return { ...state, internetStatusError: action.payload };
        case CHECK_RECONNECT_SESSION:
            return { ...state, checkSipConnection: action.payload };
        case SET_MONITORING_HUB_ERROR:
            return { ...state, monitoringHubError: action.payload };
        case SET_STATUS_HUB_ERROR:
            return { ...state, statusHubError: action.payload };
        case SET_USER_DATA_HUB_ERROR:
            return { ...state, userDataHubError: action.payload };
        case SET_TRANSCRIPTION_HUB_STATUS:
            return { ...state, transcriptionHubStatus: action.payload };
        case SET_DIALER_HUB_ERROR:
            return { ...state, dialerHubError: action.payload };
        case SET_ERROR_JS_SIP:
            return { ...state, errorJsSip: action.payload };
        case SET_ERROR_JS_SIP_TAB:
            return { ...state, errorJsSipTab: action.payload };
        case SET_ACTIVE_SESSION_TAB:
            return { ...state, activeTab: action.payload };
        case RECONNECT_TAB:
            return { ...state, reconnectTab: action.payload };
        case CLEAR_ALL_STATES:
            return initialState;
        default:
            return state;
    }
};
